<template>
  <shared-product-card :product="product" :image="image" :to="{ path: `/erp/flexy/products/${product.productId}` }"/>
</template>

<script>
  import SharedProductCard from '@/components/ProductProvide/List/Card/Shared'

  export default {
    props: {
      product: {
        type: Object,
        required: true
      }
    },
    computed: {
      image () {
        if (!this.product.variations[0].images.length) {
          return ''
        }

        return this.product.variations[0].images[0]
      }
    },
    components: {
      SharedProductCard
    }
  }
</script>



// WEBPACK FOOTER //
// Flexy.vue?68877f0e